import { NgModule, ModuleWithProviders, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

const HTML_RESPONSE_PATTERN = /^\s*<(?:!doctype|html)\b/i;

const extractSentryError = (error: unknown, defaultExtractor: (candidate: unknown) => unknown): unknown => {
  if (!(error instanceof HttpErrorResponse)) {
    return defaultExtractor(error);
  }

  if (typeof error.error !== 'string') {
    return defaultExtractor(error);
  }

  if (error.status < 500 || !HTML_RESPONSE_PATTERN.test(error.error)) {
    return defaultExtractor(error);
  }

  return new Error(`Server returned code ${error.status} with HTML response body`);
};

@NgModule()
export class SentryModule {
  static forRoot(): ModuleWithProviders<SentryModule> {
    return {
      ngModule: SentryModule,
      providers: [
        {
          provide: ErrorHandler,
          useValue: Sentry.createErrorHandler({
            showDialog: false,
            extractor: extractSentryError
          }) // optional config
        },
        {
          provide: Sentry.TraceService,
          deps: [Router]
        },
        {
          provide: APP_INITIALIZER,
          useFactory: () => () => {},
          deps: [Sentry.TraceService],
          multi: true
        }
      ]
    };
  }
}
